import { useTranslation } from '../../i18n/useTranslation';
import { default as globalStyles } from '../../global-styles.module.scss';
import { useBetween } from '../../shared/use-between/use-between';
import { ShoppingCartUseBetween } from '../order/use-between/shopping-cart-use-between';
import { FixcenterProduct } from '../../shared/models/fixcenter-product.model';
import { useState } from 'react';
import ShopingCartAlert from './shopping-cart-alert';
import { IShopingCartProduct } from '../order/interfaces/shopping-cart-product.interface';
import { IShopingCart } from '../order/interfaces/shopping-cart.interface';
import {
    addToShoppingCart,
    getShopingCartProduct,
    getTotalQuantityShoppingCart,
    shopingCartAlertVisibilityTimeInMs,
} from '../shopping-cart/services/shopping-cart.service';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import classNames from 'classnames';
import { CircularProgress, Tooltip } from '@mui/material';

interface IAddToShoppingCartProp {
    product: FixcenterProduct;
    quantity: number;
    productParentUuid: string | undefined;
    isDisabled: boolean;
    minQuantity?: number;
    netPrice: number;
    brutPrice: number;
    discount: number;
    packaging: number | null;
    familyCode: string;
    imageFileId: string | null;
}

const AddToShoppingCart: React.FC<IAddToShoppingCartProp> = ({
    product,
    quantity,
    productParentUuid,
    isDisabled,
    netPrice,
    brutPrice,
    discount,
    familyCode,
    imageFileId,
    minQuantity = null,
    packaging = null,
}) => {
    const { t } = useTranslation('translation');
    const { setShoppingCart } = useBetween(ShoppingCartUseBetween);
    const { setQuantityShoppingCart } = useBetween(ShoppingCartUseBetween);
    const { setIsReadyToOrder } = useBetween(ShoppingCartUseBetween);
    const [shopingCartAlertIsOpen, setOpenShopingCartAlert] = useState(false);
    const [isAdding, setIsAdding] = useState(false);

    const handleAddToShoppingCart = (product: IShopingCartProduct) => {
        product.packaging = packaging;
        setIsAdding(true);
        addToShoppingCart(product)
            .then((response) => {
                if (response) {
                    const data: IShopingCart = response.data;
                    setShoppingCart(data);
                    setQuantityShoppingCart(getTotalQuantityShoppingCart(data));
                    setOpenShopingCartAlert(true);
                    setIsReadyToOrder(data.isReadyToOrder);
                }
            })
            .finally(() => setIsAdding(false));
    };

    const handleOpenShopingCartAlert = () => {
        if (isAdding) {
            return;
        }
        const _minQuantity = minQuantity ?? 1;
        handleAddToShoppingCart(
            getShopingCartProduct(
                product,
                quantity,
                _minQuantity,
                netPrice,
                brutPrice,
                discount,
                familyCode,
                imageFileId,
                productParentUuid
            )
        );
    };

    return (
        <div>
            <Tooltip title={t('ADD_TO_CART')}>
                <button
                    id={'add-to-shopping-cart-btn'}
                    className={classNames(globalStyles.flex_center_item, isDisabled ? globalStyles.disabled_btn : '')}
                    disabled={isDisabled}
                    aria-busy={isAdding}
                    onClick={(e) => {
                        e.preventDefault();
                        e.currentTarget.blur();
                        handleOpenShopingCartAlert();
                    }}
                >
                    {isAdding ? (
                        <CircularProgress size={18} color="inherit" />
                    ) : (
                        <AddShoppingCartIcon style={{ fontSize: '18px' }} />
                    )}
                </button>
            </Tooltip>
            <ShopingCartAlert
                isOpen={shopingCartAlertIsOpen}
                handleCloseDialog={(val: boolean) => setOpenShopingCartAlert(val)}
                autoHideDurationInMs={shopingCartAlertVisibilityTimeInMs}
            ></ShopingCartAlert>
        </div>
    );
};
export default AddToShoppingCart;
